import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c('Header'),_c(VMain,{staticClass:"body",class:{ isAuth: _vm.isAuthenticated }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }